module.exports = __webpack_public_path__ + "static/doctorBaltazar-c49944b1d662189ca893e16a5322893f.jpg";